import { COLLECTION_RESOURCE_TYPES } from "@/shared/domain/collections/CollectionRecord";

import { resourceIdFilter } from "../resourceIdFilter";

import type { StaticFilterField } from "./StaticFilterField";

/** The collections table's filter rows, in picker order. */
export const COLLECTION_FILTER_FIELDS = [
  {
    type: "string",
    field: "collection_id",
    name: "Collection Id",
    ...resourceIdFilter,
  },
  { type: "string", field: "name", name: "Name" },
  { type: "string", field: "description", name: "Description" },
  {
    type: "enum",
    field: "resource_type",
    name: "Entity Type",
    options: COLLECTION_RESOURCE_TYPES,
  },
  { type: "date", field: "created", name: "Created" },
  { type: "string", field: "created_by", name: "Created By" },
  { type: "set", field: "tags", name: "Tags" },
] as const satisfies readonly StaticFilterField[];
